<template>
  <div class="container">
    <CategoryTitle :title="route.query.category" />
    <CategoryList>
      <CategoryItem
        v-for="item in categories"
        :key="item.title"
        :title="item.title"
        :icon="item.icon"
        @click="handleCategory(item)"
      />
    </CategoryList>
  </div>
</template>

<script setup>
import { watch, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import CategoryTitle from './components/category/category-title.vue';
import CategoryItem from './components/category/category-item.vue';
import CategoryList from './components/category/category-list.vue';

const router = useRouter();
const route = useRoute();
const categories = ref([]);

const categoryData = {
  党建园地: [
    {
      title: '党建宣传',
      icon: 'djxc',
      dataType: 5
    },
    {
      title: '红色记忆',
      icon: 'hsjy',
      dataType: 4
    }
  ],
  预警提示: [
    {
      title: '典型案例',
      icon: 'dxal',
      dataType: 1
    },
    {
      title: '风险预警',
      icon: 'fxyj',
      dataType: 3
    }
  ],
  网络宣传: [
    {
      title: '法律法规',
      icon: 'flfg',
      dataType: 2
    },
    {
      title: '文明上网',
      icon: 'wmsw',
      dataType: 6
    }
  ]
};

function handleCategory(item) {
  const category = route.query?.category;
  console.log(item, route.query);
  // router.push(`newslist?type=${item.dataType}`);
  router.push({
    name: 'newslist',
    query: { type: item.dataType, category }
  });
}

watch(
  () => route.query,
  query => {
    categories.value = categoryData[query.category];
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped></style>
